import {inject, Injectable} from '@angular/core';
import {LocalStorageService} from "../../shared/services/local-storage.service";
import {STORAGE_KEYS} from "../../shared/constants/storage-keys";

@Injectable({
    providedIn: 'root'
})
export class RealmService {
    private readonly storageService = inject(LocalStorageService)

    private readonly _realmSignal = this.storageService.signal<string | undefined>(STORAGE_KEYS.REALM, undefined);
    private readonly _mailSignal = this.storageService.signal<string | undefined>(STORAGE_KEYS.MAIL, undefined);

    public set realm(realm: string) {
        this._realmSignal.set(realm);
    }

    public get realm(): string | undefined {
        return this._realmSignal();
    }

    public set mail(mail: string) {
        this._mailSignal.set(mail);
    }

    public get mail(): string | undefined {
        return this._mailSignal();
    }

    async clearStorage() {
        this.storageService.remove(STORAGE_KEYS.REALM);
        this.storageService.remove(STORAGE_KEYS.MAIL);
    }
}
